<app-edit-user [submissionMode$]="submissionMode.CREATE" [full]="true"></app-edit-user>
